export function smtpDeliveryMode(settings = {}) {
  if (settings.configured) return "custom";
  if (settings.app_smtp_configured) return "app";
  return "missing";
}
